import { map } from 'rxjs/operators';
import ConfigManager from '@/config/ConfigManager.js';
import BzbsApi from '@/core/Http/BzbsApi.js';
import Account from '@/helper/AccountHelper.js';
import SubscriptionCouponModel from '../model/SubscriptionCouponModel';

export default {
    apiGetSubscriptionCoupon: function () {
        const token = Account.getToken();

        const url = ConfigManager.getApiModuleUrl() + '/subscription/me/coupons';
        return BzbsApi.connectBzbsGet(url, token, null).pipe(map((res) => {
            let coupons = [];
            for (let item of res.data.data) {
                let coupon = new SubscriptionCouponModel(item);
                coupons.push(coupon);
            }
            return coupons
        }));
    }
}